// Spreadsheet Submissions related store state and actions.

import axiosApiClient from '@/api/axiosApiClient'
import log from '@/utils/log'

const FETCH_LIMIT = 25

// State
export const state = {
	list: [],
	loading: false,
	error: null
}

// Getters
export const getters = {}

// Mutations
export const mutations = {
	FETCH_SUBMISSION_REQUEST(state) {
		state.loading = true
		state.error = null
	},
	FETCH_SUBMISSION_SUCCESS(state, list) {
		state.loading = false
		state.error = null
		state.list = list
	},
	FETCH_SUBMISSION_FAILURE(state, error) {
		state.loading = false
		state.error = error
	},
	RESET_SUBMISSION(state) {
		state.loading = false
		state.error = null
		state.list = []
	}
}

// Actions
export const actions = {
	// Fetches spreadsheet submissions list.
	async fetchSpreadsheetSubmissions({ commit }) {
		commit('FETCH_SUBMISSION_REQUEST')
		try {
			const { data } = await axiosApiClient.get(
				`/order-imports?limit=${FETCH_LIMIT}`
			)
			commit('FETCH_SUBMISSION_SUCCESS', data)
		} catch (error) {
			commit('FETCH_SUBMISSION_FAILURE', error)
			log.error(
				'Failed to fetch spreadsheet submissions',
				{ category: 'API' },
				error.stack
			)
		}
	},

	resetSpreadsheetSubmissions({ commit }) {
		commit('RESET_SUBMISSION')
	}
}
